import ReadMoreText from "./read-more-text";

export default ReadMoreText;
